module.exports = __webpack_public_path__ + "img/bgR5.8bc287b8.png";